import PropTypes from "prop-types"
import React from "react"
import axios from "axios"

import { CheckCircleIcon, XCircleIcon, XIcon } from "@heroicons/react/solid"
import { Link } from "gatsby"
import { Transition } from "@headlessui/react"
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const isBrowser = typeof window !== "undefined"

export class FormWrapper extends React.Component {
	constructor(props) {
		super(props)
		this.domRef = React.createRef()
		this.state = {
			success: false,
			loading: false,
			error: false,
		}
	}

	handleSubmit(event) {
		event.preventDefault()

		const formData = new FormData(this.domRef.current)

		formData.append("subject", this.props.subject)

		if (this.props.extraFields) {
			Object.keys(this.props.extraFields).forEach((key) => {
				formData.append(key, this.props.extraFields[key])
			})
		}

		if (isBrowser) formData.append("Link zum Formular", window.location.href)

		this.setState({
			loading: true,
			success: false,
			error: false,
		})

		let lock = true

		setTimeout(() => {
			lock = false
		}, 1000)

		axios
			.post("/api/formSubmit", formData, {
				"Content-Type": "multipart/form-data",
			})
			.then((response) => {
				window?.ga && window.ga("send", "event", "Angebot", "submit")

				let interval = setInterval(() => {
					if (!lock) {
						this.setState({
							success: true,
							loading: false,
						})
						clearInterval(interval)
					}
				}, 100)
			})
			.catch((err) => {
				let interval = setInterval(() => {
					if (!lock) {
						this.setState({
							error: true,
							loading: false,
						})
						clearInterval(interval)
					}
				}, 100)
			})
	}
	render() {
		return (
			<div>
				{" "}
				{!this.state.success && (
					<form
						ref={this.domRef}
						name={this.props.name}
						onSubmit={(event) => this.handleSubmit(event)}
					>
						<fieldset disabled={this.state.loading}>
							{this.props.children}
							<input
								type="text"
								name="a_password"
								className="hidden"
								tabIndex="-1"
								autoComplete="off"
							></input>
							<div className="flex justify-between flex-wrap gap-2">
								<label className="inline-flex items-center text-gray-500 text-xs sm:text-base">
									<input
										type="checkbox"
										name="datenschutz"
										className="mr-2 checkbox"
										value="Wurde akzeptiert"
										required
									/>
									<span>
										Ich akzeptiere die{" "}
										<Link
											to="/datenschutz"
											className="font-bold underline inline hover:text-primary"
										>
											Datenschutzerklärung
										</Link>
									</span>
								</label>
								<button
									type="submit"
									className="btn btn-primary flex"
									disabled={this.state.loading}
								>
									{this.state.loading && (
										<svg
											className="animate-spin -ml-1 mr-3 h-5 w-5"
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
										>
											<circle
												className="opacity-25"
												cx="12"
												cy="12"
												r="10"
												stroke="currentColor"
												strokeWidth="4"
											></circle>
											<path
												className="opacity-75"
												fill="currentColor"
												d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
											></path>
										</svg>
									)}
									Abschicken
								</button>
							</div>
						</fieldset>
					</form>
				)}
				<Transition
					show={this.state.success}
					enter="transition transform ease-out duration-200"
					enterFrom="opacity-0 -translate-y-4"
					enterTo="opacity-100 translate-y-0"
					leave="transition transform ease-in duration-150"
					leaveFrom="opacity-100 translate-y-0"
					leaveTo="opacity-0 -translate-y-4"
				>
					<div className="rounded-md bg-green-200 p-4">
						<div className="flex">
							<div className="flex-shrink-0">
								<CheckCircleIcon
									className="h-5 w-5 text-green-500"
									aria-hidden="true"
								/>
							</div>
							<div className="ml-3">
								<p className="text-sm font-medium text-green-900">
									{this.props.successMessage}
								</p>
							</div>
							<div className="ml-auto pl-3">
								<div className="-mx-1.5 -my-1.5">
									<button
										type="button"
										className="inline-flex bg-green-200 rounded-md p-1.5 text-green-600 hover:bg-green-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-200 focus:ring-green-700"
									>
										<span className="sr-only">Dismiss</span>
										<XIcon
											className="h-5 w-5"
											aria-hidden="true"
											onClick={() => this.setState({ success: false })}
										/>
									</button>
								</div>
							</div>
						</div>
					</div>
				</Transition>
				<Transition
					show={this.state.error}
					enter="transition transform ease-out duration-200"
					enterFrom="opacity-0 -translate-y-4"
					enterTo="opacity-100 translate-y-0"
					leave="transition transform ease-in duration-150"
					leaveFrom="opacity-100 translate-y-0"
					leaveTo="opacity-0 -translate-y-4"
				>
					<div className="rounded-md bg-red-50 p-4 mt-2">
						<div className="flex">
							<div className="flex-shrink-0">
								<XCircleIcon
									className="h-5 w-5 text-red-400"
									aria-hidden="true"
								/>
							</div>
							<div className="ml-3">
								<h3 className="text-sm font-medium text-red-800">
									{this.props.errorMessage ||
										"Es ist ein Fehler beim Absenden des Formulars aufgetreten."}
								</h3>
								<div className="mt-4">
									<div className="-mx-2 -my-1.5 flex">
										<button
											type="button"
											className="bg-red-50 px-2 py-1.5 rounded-md text-sm font-medium text-red-800 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-50 focus:ring-red-600"
											onClick={() =>
												this.domRef.current.querySelector("button").click()
											}
										>
											Nochmal absenden
										</button>
										<button
											type="button"
											className="ml-3 bg-red-50 px-2 py-1.5 rounded-md text-sm font-medium text-red-800 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-50 focus:ring-red-600"
											onClick={() => {
												if (isBrowser) window.location.reload()
											}}
										>
											Seite neu laden
										</button>
									</div>
								</div>
							</div>
							<div className="ml-auto pl-3">
								<div className="-mx-1.5 -my-1.5">
									<button
										type="button"
										className="inline-flex bg-red-50 rounded-md p-1.5 text-red-500 hover:bg-red-100 
                                        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-50 focus:ring-red-600"
									>
										<span className="sr-only">Dismiss</span>
										<XIcon
											className="h-5 w-5"
											aria-hidden="true"
											onClick={() => this.setState({ error: false })}
										/>
									</button>
								</div>
							</div>
						</div>
					</div>
				</Transition>
			</div>
		)
	}
}

FormWrapper.propTypes = {
	errorMessage: PropTypes.string,
	name: PropTypes.string.isRequired,
	subject: PropTypes.string.isRequired,
	successMessage: PropTypes.string.isRequired,
	extraFields: PropTypes.object,
}

export const AngebotForm = () => (
	<div className="p-8 bg-white shadow-xl">
		<h2 className="h1_5 text-primary font-bold text-center mb-4">
			<FontAwesomeIcon icon={faEnvelope} /> Wir unterbreiten Ihnen gerne ein
			Angebot!
		</h2>
		<p className="text-center mb-8">
			Kreuzen Sie die Punkte an, die Sie interessieren, füllen Sie das
			Kontaktformular aus & klicken Sie auf SENDEN.
		</p>
		<FormWrapper
			name="Angebot anfordern"
			successMessage="Vielen Dank, dass Sie uns kontaktiert haben! Wir werden uns schnellstmöglich bei Ihnen zurückmelden. Schöne Grüße, Ihr Team von Internes-Recruiting.de"
			subject="Angebotsanfrage - Startseite"
		>
			<div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
				<div className="bg-primary rounded-lg flex flex-col gap-2 p-3 text-white">
					<span className="font-bold">Bewerbergewinnung</span>
					<label className="inline-flex items-center text-xs sm:text-base">
						<input
							type="checkbox"
							name="Karriere Website"
							className="mr-2 checkbox"
							value="angekreuzt"
						/>
						Karriere-Website
					</label>
					<label className="inline-flex items-center text-xs sm:text-base">
						<input
							type="checkbox"
							name="E-Recruiting-Analyse"
							className="mr-2 checkbox"
							value="angekreuzt"
						/>
						E-Recruiting-Analyse
					</label>
					<label className="inline-flex items-center text-xs sm:text-base">
						<input
							type="checkbox"
							name="Active Sourcing"
							className="mr-2 checkbox"
							value="angekreuzt"
						/>
						Active Sourcing
					</label>
				</div>
				<div className="bg-secondary-800 rounded-lg flex flex-col gap-2 p-3 text-white">
					<span className="font-bold">Recruiting Beratung</span>

					<label className="inline-flex items-center text-xs sm:text-base">
						<input
							type="checkbox"
							name="Recruiting Strategie"
							className="mr-2 checkbox"
							value="angekreuzt"
						/>
						Recruiting Strategie
					</label>
					<label className="inline-flex items-center text-xs sm:text-base">
						<input
							type="checkbox"
							name="Recruiting Impulse"
							className="mr-2 checkbox"
							value="angekreuzt"
						/>
						Recruiting Impulse
					</label>
					<label className="inline-flex items-center text-xs sm:text-base">
						<input
							type="checkbox"
							name="Recruiting Seminare"
							className="mr-2 checkbox"
							value="angekreuzt"
						/>
						Recruiting Seminare
					</label>
				</div>
				<div className="bg-primary-900 rounded-lg flex flex-col gap-2 p-3 text-white">
					<span className="font-bold">Bewerbergewinnung</span>
					<label className="inline-flex items-center text-xs sm:text-base">
						<input
							type="checkbox"
							name="Motivation & KPI´s"
							className="mr-2 checkbox"
							value="angekreuzt"
						/>
						Motivation & KPI´s
					</label>
					<label className="inline-flex items-center text-xs sm:text-base">
						<input
							type="checkbox"
							name="Recruitervermittlung"
							className="mr-2 checkbox"
							value="angekreuzt"
						/>
						Recruitervermittlung
					</label>
					<label className="inline-flex items-center text-xs sm:text-base">
						<input
							type="checkbox"
							name="Recruiter mieten"
							className="mr-2 checkbox"
							value="angekreuzt"
						/>
						Recruiter mieten
					</label>
				</div>
				<div className="flex flex-col gap-2 p-3">
					<span className="font-bold">Sonstiges</span>
					<label className="inline-flex items-center text-xs sm:text-base">
						<input
							type="checkbox"
							name="Individuelles Angebot"
							className="mr-2 checkbox"
							value="angekreuzt"
						/>
						Individuelles Angebot
					</label>
				</div>
				<label className="flex flex-col text-gray-500">
					Name*
					<input
						className="input text-black"
						type="text"
						name="name"
						required
					/>
				</label>
				<label className="flex flex-col text-gray-500">
					Geschäftliche E-Mail*
					<input
						className="input text-black"
						type="email"
						name="email"
						required
					/>
				</label>
				<label className="flex flex-col text-gray-500">
					Telefon
					<input
						required
						className="input text-black"
						pattern="[0-9]*\/*(\+49)*[ ]*(\([0-9]+\))*([ ]*(-|–)*[ ]*[0-9]+)*"
						type="tel"
						name="Telefon"
					/>
				</label>
				<label className="flex flex-col text-gray-500">
					Firma
					<input className="input text-black" type="text" name="Firma" />
				</label>
			</div>

			<label className="flex flex-col text-gray-500 mb-3 mt-2">
				Nachricht
				<textarea className="input text-black" rows="8" name="nachricht" />
			</label>
		</FormWrapper>
	</div>
)
